module.exports = __webpack_public_path__ + "static/media/logo-blanco-profi.af52da12.svg";